import { Language } from '@mui/icons-material'
import { Autocomplete, Box, Radio, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFilteredCountries } from '../../../../redux/actions/countries'
import { setGlobalCountries } from '../../../../redux/actions/global'
import { IRootState } from '../../../../redux/types'
import useScreenWidth from '../../hooks/useScreenWidth'

const optionAll = [{ id: 0, code: 'AL', name: 'Todos' }]

interface ICountry {
  id: number
  code: string
  name: string
}

function CountryFilter() {
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { countries, loading } = useSelector((state: IRootState) => state.country)
  const { globalCountriesId } = useSelector((state: IRootState) => state.global)
  const [allCheck, setAllCheck] = useState(true)

  const handleMultiAutoCompleteChange = (value: ICountry[]) => {
    let optionsMulti: number[] = []
    if (value !== null) {
      for (let i = 0; i < value.length; i++) {
        if (value[i].id === 0) {
          if (globalCountriesId.length === 0) {
            setAllCheck(true)
            optionsMulti = authUser.countries
          } else {
            setAllCheck(false)
            optionsMulti = []
          }
          break
        }

        optionsMulti.push(value[i].id)
      }
    }

    dispatch(setGlobalCountries(optionsMulti))
  }

  useEffect(() => {
    if (countries.length === 0) dispatch(getFilteredCountries())

    if (authUser !== null && localStorage.getItem('globalCountriesId') === null) dispatch(setGlobalCountries(authUser.countries))
  }, [authUser])

  return (
    <Box display="flex" alignItems="center">
      <Box>{<Language color="secondary" />}</Box>
      {authUser !== null && countries.length > 0 && (
        <Autocomplete
          sx={{ '&.MuiAutocomplete-popper': { width: 'min-content !important' } }}
          id="multiple-limit-tags"
          options={[...optionAll, ...countries]}
          value={countries.filter((country: ICountry) => globalCountriesId.includes(country.id))}
          limitTags={1}
          disableCloseOnSelect
          disableClearable
          multiple
          loading={loading}
          getOptionLabel={(country: ICountry) => (country.id !== undefined ? country.name : '')}
          renderTags={(countries: ICountry[]) =>
            isMobile ? `+${countries.length}` : countries.length === 1 ? countries[0].name : `${countries[0].name}, +${countries.length}`
          }
          renderOption={(props, country: ICountry, { selected }: any) => (
            <li {...props}>
              <Radio key={country.id} checked={country.id === 0 ? allCheck : selected} />
              {country.name}
            </li>
          )}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              sx={{
                paddingX: 0.5,
                paddingY: 0,
                margin: 0,
                '& .MuiInputBase-root': { paddingRight: '0px !important' },
                '& .MuiAutocomplete-endAdornment': { right: 15 }
              }}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true
              }}
            />
          )}
          onChange={(_, newValue) => handleMultiAutoCompleteChange(newValue)}
        />
      )}
    </Box>
  )
}

export default CountryFilter
